import { Injectable } from '@angular/core';
import { TpTravelService } from 'src/app/core/api/tptravel.service';
import { Flight, Segment } from 'src/app/core/models/itinerary.model';

@Injectable()
export class AirportIconsService {
  constructor(private tpTravelService: TpTravelService) {}

  setIconFlight(flight: Flight): Flight {
    flight.urlIcon = flight.operatingCarrier
      ? this.tpTravelService.getIconAirline(flight.operatingCarrier.code)
      : '';
    return flight;
  }

  setIcons(segment: Segment): Segment {
    segment.iconsUrl = [];
    segment.recommendationFlights.forEach((flight) => {
      flight.urlIcon = flight.operatingCarrier
        ? this.tpTravelService.getIconAirline(flight.operatingCarrier.code)
        : '';
      segment.iconsUrl.push(flight.urlIcon);
    });
    segment.flights.forEach((flight) => {
      flight.urlIcon = flight.operatingCarrier
        ? this.tpTravelService.getIconAirline(flight.operatingCarrier.code)
        : '';
      segment.iconsUrl.push(flight.urlIcon);
    });
    segment.iconsUrl = this.uniqueIcons(segment.iconsUrl);

    return segment;
  }

  uniqueIcons(segmentIconsUrl: string[]): string[] {
    return segmentIconsUrl.filter((val, i, self) => self.indexOf(val) === i);
  }
}
